import React, { useEffect } from 'react';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Box from '@nubank/nuds-web/components/Box/Box';
import Image from '@nubank/nuds-web/components/Image/Image';
import styled from 'styled-components';

import useFigPiiExperiment from '@nubank/www-latam-commons/utils/figpii/useFigPiiExperiment';

import { useDynamicYieldValues } from '../../../../../../../../utils/dynamicYield';
import CloseBtn from '../Commons/CloseBtn';
import LinkGat from '../Commons/LinkGat';
import MagicLinkBtn from '../Commons/MagicLinkBtn';
import { ccRatesEvent } from '../../../../../../tracking';
import AppStoreButtons from '../Commons/AppStoreButtons';
import { MAGIC_LINK_FIX_EXPERIMENT_ID, MAGIC_LINK_FIX_EXPERIMENT_VARIANT } from '../../../../../../../../utils/experiments';

const StyledTitle = styled(Typography)`
  font-size: 26px;
`;

const StyledBox = styled(Box)`
  gap: 8px;
  
  p {
    flex: 1;
  }
`;

const Line = styled(Box)`
  border: 1px solid rgba(17 17 17 / 10%);
  margin-top: 5px;
  width: 97%;
`;

function ZeroRateControl() {
  const activeVariant = useFigPiiExperiment(MAGIC_LINK_FIX_EXPERIMENT_ID);

  const { values: dynamicYieldValues } = useDynamicYieldValues();
  useEffect(() => {
    ccRatesEvent('apr default');
  },
  []);

  return (
    <Box>
      <CloseBtn />
      <StyledTitle
        variant="heading2"
        marginTop="6x"
      >
        Esta es tu
        <StyledTitle variant="heading2" color="primary" tag="span">
          {' '}
          oferta preaprobada
        </StyledTitle>

        , continúa y elige lo que quieres contratar
      </StyledTitle>
      ️

      <Box marginBottom="8x" marginTop="10px">
        {/* IMAGE BLOCK */}
        <StyledBox
          marginTop="18x"
          marginBottom="6x"
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          padding={{ xs: '6x', lg: '8x' }}
          backgroundColor="#820AD1"
          paddingVertical="4x"
          borderRadius="25px 25px 0px 0px"
        >
          <Box marginTop="-92px">
            <Image
              alt="Icono de una tarjeta"
              src="one-step/rtr/credit-zero-rate.svg"
              webp
              width="104px"
              height="101px"
            />
          </Box>

          <Typography
            variant="paragraph1"
            color="white"
            marginTop="-8px"
            marginBottom="-5px"
            strong
          >
            Tarjeta de Crédito $0 anualidad sin mínimo de compras
          </Typography>
        </StyledBox>
        <Box
          backgroundColor="#F3EDFF"
          borderRadius="0px 0px 25px 25px"
          marginTop="-24px"
          marginBottom="6x"
          paddingHorizontal={{ xs: '6x', lg: '8x' }}
          paddingVertical="2x"
        >
          <Typography variant="paragraph1">
            Más MSI, y opciones de pago flexibles.
          </Typography>
        </Box>

        <StyledBox
          marginTop="60px"
          marginBottom="6x"
          padding={{ xs: '6x', lg: '8x' }}
          backgroundColor="#F3EDFF"
          paddingVertical="4x"
          borderRadius="25px"
        >
          <Box marginTop="-65px">
            <Image
              alt="Icono de una tarjeta"
              src="one-step/rtr/cuenta-zero-rate.svg"
              webp
              width="83px"
              height="78px"
            />
          </Box>

          <Typography variant="paragraph1" strong>
            Cuenta Nu de Débito:
            <Typography variant="paragraph1" tag="span">
              {' '}
              En la app puedes hacer crecer tus ahorros
              {' '}
            </Typography>
            {' '}
            hasta un
            {' '}
            {`${dynamicYieldValues.dynamicYieldTurbo}% al año`}
          </Typography>
        </StyledBox>

      </Box>

      {/* BENEFITS LIST */}

      <Box marginBottom="12x" marginTop="2x">
        <Typography variant="heading4" strong>
          Qué beneficios te da Nu:
        </Typography>

        <Line tag="hr" />

        <Box
          marginTop="6x"
          display="flex"
          flexDirection="row"
        >
          <Image
            alt="Icono de corazón"
            src="one-step/rtr/heart.svg"
            webp={false}
            width="24px"
          />
          <Typography
            variant="paragraph1"
            marginLeft="4x"
            marginTop="-2px"
            color="#000000A3"
          >
            <Typography
              tag="span"
              strong
              variant="paragraph1"
              color="black"
            >
              $0 anualidad
              {' '}
            </Typography>
            ni comisiones por uso mínimo.
          </Typography>
        </Box>

        <Box
          marginTop="4x"
          display="flex"
          flexDirection="row"
        >
          <Image
            alt="Icono de carita feliz"
            src="one-step/rtr/smiley.svg"
            webp={false}
            width="24px"
          />
          <Typography
            variant="paragraph1"
            marginLeft="4x"
            marginTop="-2px"
            color="#000000A3"
          >
            Atención
            <Typography
              tag="span"
              strong
              variant="paragraph1"
              color="black"
            >
              {' '}
              humana y soporte las 24/7.
            </Typography>
          </Typography>
        </Box>

        <Box
          marginTop="6x"
          display="flex"
          flexDirection="row"
        >
          <Image
            alt="Icono de escudo"
            src="one-step/rtr/shield.svg"
            webp={false}
            width="36px"
          />
          <Typography
            variant="paragraph1"
            marginLeft="4x"
            color="#000000A3"
          >
            Tecnología para
            <Typography
              tag="span"
              strong
              variant="paragraph1"
              color="black"
            >
              {' '}
              cuidar que solo tú apruebes
              {' '}
            </Typography>
            y sepas de cada transacción.
          </Typography>
        </Box>
      </Box>

      {activeVariant === MAGIC_LINK_FIX_EXPERIMENT_VARIANT ? (
        <AppStoreButtons />
      ) : (
        <MagicLinkBtn label="Continuar" hideIcon />
      )}

      {/* GAT LINK */}
      <Box
        marginTop="8x"
        display="flex"
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
      >
        <LinkGat
          label="Conoce la GAT de Cuenta Nu"
        />
      </Box>

    </Box>
  );
}

export default ZeroRateControl;
